import React from 'react'
import './footer.css'
export default function Footer() {
 
  return (
 
    <div className="contain">
    <p>&copy; 2023 enimic.All rights reserved.</p>
    <ul>
      <li>Twitter</li>
      <li>facebook</li>
      <li>Instagram</li>
       

    </ul>
  
  </div>
  )
}
